import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import chatSvg from '../assets/chat-icon.svg';
import alexLogo from '../assets/alex-logo.svg';
import Standalone from './Standalone';

export const POPUP_WIDTH = 375;
export const POPUP_HEIGHT = 608;

export const POPUP_OPTIONS = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=100,top=100`;

function OpenPopup(): JSX.Element {
  const { customerId } = useParams<{ customerId: string }>();
  const [popupsEnabled, setPopupsEnabled] = useState<boolean | null>(null);
  const { rudderanalytics, document } = window;

  const tryOpenPopup = useCallback(() => {
    // IE 11 does not support multiple instances of the app running in one window. Just show the inline version
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Property 'documentMode' does not exist
    if (window.document.documentMode) {
      setPopupsEnabled(false);
      rudderanalytics.track('open_chat', {
        mode: 'popup',
        popupsEnabled,
        referrer: document.referrer || 'self',
      });
      return;
    }

    const popup = window.open(
      `/standalone/${customerId}${window.location.search}`,
      'chat',
      POPUP_OPTIONS
    );

    if (popupsEnabled !== null) {
      rudderanalytics.track('open_chat', {
        mode: 'popup',
        popupsEnabled,
        referrer: document.referrer || 'self',
      });
    }

    setTimeout(() => {
      setPopupsEnabled(popup !== null);

      // NOTE: resizeBy is necessary for Safari
      popup?.resizeBy(POPUP_WIDTH - popup.innerWidth, POPUP_HEIGHT - popup.innerHeight);
    }, 100);
  }, [customerId, rudderanalytics, document.referrer, popupsEnabled]);

  useEffect(() => {
    setTimeout(() => {
      tryOpenPopup();
    }, 1200);
  }, [tryOpenPopup]);

  const chatStandalone = (content: JSX.Element, wrapperClass = '') => {
    return (
      <div className={`chat-standalone-wrapper ${wrapperClass}`}>
        <div className="chat-standalone-header">
          <img src={alexLogo} alt="ALEX logo" />
        </div>
        <div className="chat-standalone-body">{content}</div>
      </div>
    );
  };

  if (popupsEnabled) {
    return chatStandalone(
      <div className="chat-standalone-loaded text-center">
        <img src={chatSvg} alt="Alex Chat logo" className="chat-logo" />
        <h2 className="mt-4 mb-5">Thanks for chatting with ALEX</h2>
        <p>
          Your chat should have opened in its own window. If nothing happened, click the button
          below to try again.
        </p>
        <button className="btn" type="button" onClick={tryOpenPopup} data-testid="relaunch-popup">
          Launch Chat
        </button>
      </div>
    );
  }

  if (popupsEnabled === false) {
    return <Standalone />;
  }

  return chatStandalone(
    <div className="chat-standalone-loading text-center">
      <img src={chatSvg} alt="Alex Chat logo" className="chat-logo" />
      <h2 className="mt-4">ALEX is joining the chat</h2>
    </div>
  );
}

export default OpenPopup;
